module.exports = __webpack_public_path__ + "img/232.ebc1d26d.png";